import { UNIQUE_ROLES } from 'clickNgo/entities/contact'

export const getUniqueRolesToReassign = (roles: string[]) => {
  return roles.filter((role) => UNIQUE_ROLES.includes(role)).map((role) => ({ role }))
}
